(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youtube-creator-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ap-ph-video-reviews')) customElements.define('ap-ph-video-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this._aprReady) return;
      this._aprReady = true;
      const controller = new AbortController();
      this._aprController = controller;
      const root = this.querySelector('.ap-ph-reviews');
      if (!root) return;

    const rail = root.querySelector('[data-apr-rail]');
    const dialog = root.querySelector('[data-apr-dialog]');
    const player = root.querySelector('[data-apr-player]');
    const stage = root.querySelector('.ap-ph-reviews__stage');
    const previous = root.querySelector('[data-apr-prev]');
    const next = root.querySelector('[data-apr-next]');
    const categoryNav = root.querySelector('[data-apr-categories]');

    function parseYouTubeUrl(value) {
      let url;
      try { url = new URL(String(value || '').trim()); } catch (_) { return null; }
      const host = url.hostname.toLowerCase();
      const validHosts = ['youtube.com', 'www.youtube.com', 'm.youtube.com', 'music.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com', 'youtu.be', 'www.youtu.be'];
      if (!validHosts.includes(host) || !['https:', 'http:'].includes(url.protocol)) return null;
      let id = '';
      let short = false;
      if (host === 'youtu.be' || host === 'www.youtu.be') {
        id = url.pathname.split('/')[1] || '';
      } else if (url.pathname === '/watch') {
        id = url.searchParams.get('v') || '';
      } else {
        const match = url.pathname.match(/^\/(shorts|embed|live|v)\/([A-Za-z0-9_-]{11})(?:\/|$)/);
        if (match) { id = match[2]; short = match[1] === 'shorts'; }
      }
      return /^[A-Za-z0-9_-]{11}$/.test(id) ? { id, short } : null;
    }

    root.querySelectorAll('[data-apr-video-url]').forEach((card) => {
      const video = parseYouTubeUrl(card.dataset.aprVideoUrl);
      if (!video) {
        card.closest('.ap-ph-reviews__item').hidden = true;
        return;
      }
      card.dataset.aprVideoId = video.id;
      card.dataset.aprIsShort = video.short ? 'true' : 'false';
      card.dataset.aprValid = 'true';
      const autoCover = card.querySelector('[data-apr-auto-cover]');
      if (autoCover) autoCover.src = 'https://i.ytimg.com/vi/' + encodeURIComponent(video.id) + '/hqdefault.jpg';
    });

    const validCards = Array.from(root.querySelectorAll('[data-apr-valid="true"]'));
    const categories = new Map();
    function getCardCategories(card) {
      const fields = ['data-apr-category', 'data-apr-category-2', 'data-apr-category-3', 'data-apr-category-4'];
      return [...new Set(fields.flatMap((field) => String(card.getAttribute(field) || '')
        .split(/[,，;；\n]+/).map((value) => value.trim()).filter(Boolean)))];
    }
    validCards.forEach((card) => getCardCategories(card).forEach((label) => {
      const key = label.toLocaleLowerCase();
      if (!categories.has(key)) categories.set(key, label);
    }));

    function setCategory(key) {
      validCards.forEach((card) => {
        card.closest('.ap-ph-reviews__item').hidden = Boolean(key && !getCardCategories(card).some((label) => label.toLocaleLowerCase() === key));
      });
      categoryNav.querySelectorAll('[data-apr-category-key]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.aprCategoryKey === key));
      });
      rail.scrollLeft = 0;
      requestAnimationFrame(updateArrows);
    }

    if (categories.size) {
      function addCategoryButton(label, key) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ap-ph-reviews__category';
        button.dataset.aprCategoryKey = key;
        button.setAttribute('aria-pressed', String(key === ''));
        button.textContent = label;
        categoryNav.appendChild(button);
      }
      addCategoryButton(categoryNav.dataset.aprAllLabel || 'All', '');
      categories.forEach((label, key) => addCategoryButton(label, key));
      categoryNav.hidden = false;
    }

    function updateArrows() {
      if (!rail || !previous || !next) return;
      previous.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
    }

    function moveRail(direction) {
      if (!rail) return;
      const item = rail.querySelector('.ap-ph-reviews__item:not([hidden])');
      const gap = parseFloat(getComputedStyle(rail).gap) || 0;
      const distance = (item ? item.getBoundingClientRect().width : rail.clientWidth) + gap;
      rail.scrollBy({ left: distance * direction, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }

    function openVideo(button) {
      const id = button.dataset.aprVideoId;
      if (!/^[A-Za-z0-9_-]{11}$/.test(id || '')) return;
      stage.classList.toggle('is-short', button.dataset.aprIsShort === 'true');
      const frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';
      frame.title = button.dataset.aprVideoLabel || 'YouTube review';
      frame.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      frame.setAttribute('allowfullscreen', '');
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      player.replaceChildren(frame);
      dialog.showModal();
    }

    function closeVideo() {
      if (dialog.open) dialog.close();
      player.replaceChildren();
      stage.classList.remove('is-short');
    }

    root.addEventListener('click', (event) => {
      const category = event.target.closest('[data-apr-category-key]');
      if (category && categoryNav.contains(category)) { setCategory(category.dataset.aprCategoryKey); return; }
      const card = event.target.closest('[data-apr-video-url]');
      if (card && root.contains(card)) { openVideo(card); return; }
      if (event.target.closest('[data-apr-prev]')) moveRail(-1);
      if (event.target.closest('[data-apr-next]')) moveRail(1);
      if (event.target.closest('[data-apr-close]')) closeVideo();
    }, { signal: controller.signal });

    dialog.addEventListener('click', (event) => { if (event.target === dialog) closeVideo(); }, { signal: controller.signal });
    dialog.addEventListener('close', () => player.replaceChildren(), { signal: controller.signal });
    rail?.addEventListener('scroll', updateArrows, { passive: true, signal: controller.signal });
    window.addEventListener('resize', updateArrows, { signal: controller.signal });
    updateArrows();

    root.addEventListener('shopify:block:select', (event) => {
      if (event.target.closest('.ap-ph-reviews__item')) setCategory('');
    }, { signal: controller.signal });
      this._aprCloseVideo = closeVideo;
    }

    disconnectedCallback() {
      this._aprCloseVideo?.();
      this._aprController?.abort();
      this._aprReady = false;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
